(function () {
  function refreshOffers() {
    document.querySelectorAll('[data-bm-oct-urgency]').forEach(function (box) {
      var deadline = Date.parse(box.getAttribute('data-deadline') || '');
      var remaining = deadline - Date.now();
      if (!Number.isFinite(deadline) || remaining <= 0) {
        box.hidden = true;
        return;
      }
      var days = Math.floor(remaining / 86400000);
      var hours = Math.floor((remaining % 86400000) / 3600000);
      var minutes = Math.floor((remaining % 3600000) / 60000);
      function put(selector, value) {
        var field = box.querySelector(selector);
        if (field) field.textContent = String(value).padStart(2, '0');
      }
      put('[data-bm-days]', days);
      put('[data-bm-hours]', hours);
      put('[data-bm-minutes]', minutes);
      box.hidden = false;
    });
  }
  if (!window.__bravmenOctoberTimer) {
    window.__bravmenOctoberTimer = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refreshOffers, { once: true });
    } else {
      refreshOffers();
    }
    document.addEventListener('shopify:section:load', refreshOffers);
    window.setInterval(refreshOffers, 30000);
  }
}());